const TagStyle = {
  baseStyle: {},
  variants: {
    orange: {
      bg: "#ffd29c",
      color: "#c45f1e",
    },
    yellow: {
      bg: "#F3E4AD",
      color: "#777200",
    },
    green: {
      bg: "#E5F6F0",
      color: "#347B32",
    },
    red: {
      bg: "#ff9b9b",
      color: "#a30000",
    },
    purple: {
      bg: "purple.200",
      color: "purple.500",
    },
    gray: {
      bg: "gray.200",
      color: "gray.700",
    },
    pink: {
      bg: "pink.200",
      color: "pink.800",
    },
  },
};

export default TagStyle;
